import { NodeConfig } from '@antv/g6';

export function generateRandomNumber() {
  // 使用 window.crypto 获取随机数生成器
  const randomValues = new Uint32Array(2);
  window.crypto.getRandomValues(randomValues);

  // 将两个32位整数合并为一个64位整数
  const combinedValue = randomValues[0] * 0x100000000 + randomValues[1];

  // 将整数转换为字符串，并确保有18位数字
  const random18Digits = combinedValue.toString().slice(0, 18);

  // 返回生成的随机数
  return random18Digits;
}
